import { render, staticRenderFns } from "./RedirectToLoginOrOldPeak.vue?vue&type=template&id=4c611dc2&scoped=true&"
import script from "./RedirectToLoginOrOldPeak.vue?vue&type=script&lang=ts&"
export * from "./RedirectToLoginOrOldPeak.vue?vue&type=script&lang=ts&"
import style0 from "./RedirectToLoginOrOldPeak.vue?vue&type=style&index=0&id=4c611dc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c611dc2",
  null
  
)

export default component.exports